// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
// console.log('Vite ⚡️ Rails')

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application.jsx' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

// console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')
//
// // Import all channels.
// import.meta.globEager('./**/*_channel.js')
//

import "@hotwired/turbo-rails";
import "flowbite";
import "flowbite-datepicker";
import { Datepicker } from "flowbite";
import Toastr from "toastr2";
// import Rails from "@rails/ujs";
import Alpine from "alpinejs";
import dialog from "../components/dialog";
import select from "../components/select";
import ApexCharts from "apexcharts";
window.ApexCharts = ApexCharts;

const toastr = new Toastr({
  closeButton: true,
  showEasing: "swing",
  hideEasing: "swing",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
  progressBar: true,
  showDuration: 300,
  hideDuration: 1000,
  timeOut: 5000,
  extendedTimeOut: 1000,
});

window.Toastr = toastr;

Alpine.data("Dialog", dialog);
Alpine.data("Select", select);
Alpine.data("turboRedirect", (url = null) => ({
  init() {
    url = url || this.$el.getAttribute("data-url");
    if (url) {
      window.Turbo.visit(url);
      this.$el.remove();
    }
  },
}));
window.Alpine = Alpine;
Alpine.start();

let postTurboInit = function (frame) {
  const datepickers = frame.getElementsByClassName("datepicker-input");
  for (let i = 0; i < datepickers.length; i++) {
    new Datepicker(datepickers[i]);
  }
};

window.postTurboInit = postTurboInit;

document.addEventListener("turbo:load", (_event) => {
  const datepickers = document.getElementsByClassName("datepicker-input");
  for (let i = 0; i < datepickers.length; i++) {
    new Datepicker(datepickers[i]);
  }
});

document.addEventListener("turbo:render", (_event) => {
  // Alpine.start();
  const datepickers = document.getElementsByClassName("datepicker-input");
  for (let i = 0; i < datepickers.length; i++) {
    new Datepicker(datepickers[i]);
  }
});

document.addEventListener("turbo:submit-start", function (event) {
  // if (event.target.hasAttribute("data-turbo-frame")) {
  //   // Get the form data
  //   const formData = new FormData(event.target);
  //   const params = new URLSearchParams();
  //   // Add non-empty form values to URL params
  //   for (const [key, value] of formData.entries()) {
  //     if (value) params.append(key, value);
  //   }
  //   // Update the URL without reloading the page
  //   const newUrl = `${window.location.pathname}?${params.toString()}`;
  //   history.pushState({}, "", newUrl);
  // }
});
